export const workbenchResources = {
  "zh-CN": {
    workbench: {
      page: {
        expandHistory: "展开历史面板",
        returnHome: "返回工作台",
        workspaceHomeLabel: "工作台",
        assistantUnavailable: "AI 助手尚未对当前租户开通",
      },
      portal: {
        projectSpace: "项目空间",
        projectSpaceDescription: "报价、投标、科研等工作流项目",
        documentSpace: "文档空间",
        documentSpaceDescription: "模板驱动的长文档生成任务",
        create: "新建",
        enterAll: "进入全部 ▸",
      },
      workspaceBar: {
        title: "工作区",
        projectTitle: "项目工作流",
        projectDescription: "报价、投标、方案等项目制工作区",
        docGenerationTitle: "文档生成",
        docGenerationDescription: "基于模板批量生成任务文档",
      },
      resourcePanels: {
        sectionLabel: "项目与知识库",
        projectsTitle: "我的项目",
        allProjects: "全部项目",
        noActiveProjects: "暂无进行中的项目",
        updatedAt: "更新于 {{date}}",
        inProgress: "进行中",
        projectTypes: {
          ssQuota: "报价", bid: "投标", research: "科研", technical: "技术方案", general: "通用",
          ssBidCollab: "投标协同", dailyChemical: "配方", docOrganize: "文档整理", solution: "方案", sheetFilling: "表格填报",
        },
        knowledgeBaseTitle: "知识库",
        manageKnowledgeBases: "管理",
        seedTitle: "注入示例知识库",
        seedPending: "准备中…",
        seedDescription: "预置 inFab 产品文档，立即体验问答",
        seedStarted: "演示知识库已开始准备，解析完成后即可提问",
        seedFailed: "注入失败，请稍后重试",
        createKnowledgeBase: "新建知识库",
        createDescription: "上传文档，供对话与引用",
      },
      historyPanel: {
        typeAll: "全部",
        typeChat: "对话",
        typeProject: "项目",
        typeDocgen: "文档",
        searchPlaceholder: "搜索历史",
        collapse: "收起历史面板",
        noMatch: "无匹配记录",
      },
      history: {
        kindChat: "对话",
        kindProject: "项目",
        kindDocgen: "文档生成",
        kindDocgenShort: "文档",
        untitledConversation: "未命名会话",
        pinned: "置顶",
        today: "今天",
        yesterday: "昨天",
        withinWeek: "7 天内",
        earlier: "更早",
        moveFailed: "移动失败",
        projectArchived: "项目已归档",
        archiveFailed: "归档失败",
        projectDeleted: "项目已删除",
        taskDeleted: "任务已删除",
        moreActions: "更多操作",
        pin: "置顶",
        unpin: "取消置顶",
        moveToGroup: "移动到分组",
        noGroups: "暂无分组",
        moveOutOfGroup: "移出分组",
        archive: "归档",
        delete: "删除",
        manageGroups: "分组管理",
        rename: "重命名",
        deleteGroup: "删除分组",
        deleteGroupDescription: "删除「{{name}}」后，组内条目会回到时间线，不会被删除。",
        confirmDelete: "确认删除",
        deleteItemDescription: "将删除「{{title}}」。此操作不可撤销。",
        renameFailed: "重命名失败",
        groupDeleted: "分组已删除",
        deleteFailed: "删除失败",
        noRecords: "暂无记录",
        noRecentWork: "暂无最近工作",
      },
      create: {
        new: "新建",
        newChat: "新建对话",
        newProject: "新建项目",
        newDocgen: "新建生成任务",
        moreOptions: "更多新建选项",
        more: "更多新建",
        createGroup: "新建分组",
        groupCreated: "分组已创建",
        groupCreateFailed: "创建分组失败",
        groupNamePlaceholder: "分组名称",
        cancel: "取消",
        create: "创建",
      },
      emptyState: {
        seedReady: "演示知识库已开始准备，解析完成后即可提问",
        seedFailed: "注入失败，请稍后重试",
        seedTitle: "注入示例知识库",
        preparing: "准备中…",
        seedDescription: "预置 inFab 产品文档，立即体验问答",
      },
      chat: {
        assistantConfigHint: "使用智能体已发布的模型与配置",
        selectModel: "选择模型",
        openWorkshop: "打开智能体工坊",
        workshop: "智能体工坊",
        inputPlaceholder: "输入你的问题…",
        docgenExcelPrompt: "描述你要的表格，发送后直接生成 Excel",
        docgenHtmlPrompt: "描述你要的网页内容，发送后直接生成 HTML",
        openWritingStyle: "已打开写作风格页：上传历史样稿即可教 AI 公司写法",
        artifactsLoading: "产物面板加载中…",
        citationPreviewFailed: "知识库引用预览加载失败",
      },
      composer: {
        attachmentParseComplete: "附件解析完成",
        attachmentParseFailed: "附件解析失败",
        visionUnsupported: "当前模型不支持视觉能力，请切换到 VLM 模型（GPT-4o / Claude 3.5 / GLM-4V）",
        attachmentUploadFailed: "「{{name}}」上传失败",
        emptyCorpusReference: "语料引用返回为空",
        documentReferenceFailed: "「{{name}}」语料引用失败，请在文件中心完成解析后重试",
        viewFile: "查看文件",
        preciseParseComplete: "「{{name}}」精确解析完成",
        preciseParseFailed: "「{{name}}」精确解析失败：{{error}}",
        unknownError: "未知错误",
        placeholder: "有什么可以帮你？例如：总结报告要点、起草投标方案、调研行业动态…",
        placeholderActive: "输入你的问题…",
        trySuggestions: "试试这样问",
        suggestionsAria: "建议问题",
        attachmentsParsing: "附件正在解析中，请稍候…",
        removeUnreadableAttachment: "请移除读取失败的文件后再发送",
        researchSourcesForBot: "请补充研究资料，联网范围沿用智能体发布配置",
        researchSourcesForAssistant: "请添加研究资料或开启联网搜索",
        referenceFailed: "引用失败：{{name}}",
        uploadProgress: "正在上传 {{current}}/{{total}} · {{name}}",
        attachmentUsageTitle: "附件预计 {{attachmentTokens}} / {{contextTokens}} tokens，仅用于阅读量提示；支持工具调用时会按需分批阅读。单文件不超过 20MB",
        attachmentUsage: "文件阅读量",
        attachmentBatching: "将分批阅读",
        stopGenerating: "停止生成",
        send: "发送",
        aiDisclaimer: "内容由 AI 生成，可能不准确，请注意核实",
        taskMenu: "任务",
        currentAssistant: "当前智能体",
        createResearchReport: "生成研究报告",
        runAssistantTask: "执行{{name}}任务",
        organizeTitle: "选择文件夹交给 AI 整理：生成摘要、关键词、命名与标签提案，确认后生效",
        organizeDocuments: "整理文档…",
        formatWord: "Word 文档",
        formatPpt: "PPT 演示",
        formatExcel: "Excel 表格",
        formatHtml: "网页 HTML",
      },
      greeting: {
        welcome: "欢迎",
        nameSeparator: "，",
        phrases: {
          lateNight: ["夜深了", "还在忙呀", "夜猫子好", "夜色正浓", "也该歇歇了"],
          earlyMorning: ["清晨好", "起得真早", "破晓时分", "晨光正好", "新的一天从早开始"],
          morning: ["早上好", "早安", "新的一天", "元气满满", "今天也要加油"],
          noon: ["中午好", "午饭时间", "午后小憩", "好好吃饭", "小憩片刻"],
          afternoon: ["下午好", "下午茶时间", "继续加油", "保持专注", "下午冲一冲"],
          evening: ["晚上好", "晚间时光", "辛苦了", "放松一下", "今晚也从容"],
        },
      },
      suggestion: {
        title: "AI 建议待确认：{{items}}",
        label: "AI 建议",
      },
      spaceViewing: {
        readOnly: "正在查看 {{name}} 的空间，内容只读",
        otherUser: "其他用户",
      },
    },
  },
  "en-US": {
    workbench: {
      page: {
        expandHistory: "Expand history panel",
        returnHome: "Return to workspace home",
        workspaceHomeLabel: "Workspace",
        assistantUnavailable: "AI Assistant is not enabled for this tenant",
      },
      portal: {
        projectSpace: "Project space",
        projectSpaceDescription: "Workflow projects for bids, research, proposals, and more",
        documentSpace: "Document space",
        documentSpaceDescription: "Template-driven long-form document generation tasks",
        create: "New",
        enterAll: "View all ▸",
      },
      workspaceBar: {
        title: "Workspaces",
        projectTitle: "Project workflows",
        projectDescription: "Workspaces for quote, bid, and solution projects",
        docGenerationTitle: "Document generation",
        docGenerationDescription: "Generate project documents in batches from templates",
      },
      resourcePanels: {
        sectionLabel: "Projects and knowledge bases",
        projectsTitle: "My projects",
        allProjects: "All projects",
        noActiveProjects: "No active projects",
        updatedAt: "Updated {{date}}",
        inProgress: "In progress",
        projectTypes: {
          ssQuota: "Quotation", bid: "Bid", research: "Research", technical: "Technical solution", general: "General",
          ssBidCollab: "Bid collaboration", dailyChemical: "Formulation", docOrganize: "Document organization", solution: "Solution", sheetFilling: "Spreadsheet filling",
        },
        knowledgeBaseTitle: "Knowledge base",
        manageKnowledgeBases: "Manage",
        seedTitle: "Set up demo knowledge base",
        seedPending: "Preparing…",
        seedDescription: "Try Q&A with inFab product documentation",
        seedStarted: "The demo knowledge base is being prepared. You can ask questions after parsing finishes.",
        seedFailed: "Could not set it up. Try again shortly.",
        createKnowledgeBase: "Create a knowledge base",
        createDescription: "Upload documents for conversations and citations",
      },
      historyPanel: {
        typeAll: "All",
        typeChat: "Chats",
        typeProject: "Projects",
        typeDocgen: "Documents",
        searchPlaceholder: "Search history",
        collapse: "Collapse history panel",
        noMatch: "No matching records",
      },
      history: {
        kindChat: "Chat",
        kindProject: "Project",
        kindDocgen: "Document generation",
        kindDocgenShort: "Document",
        untitledConversation: "Untitled chat",
        pinned: "Pinned",
        today: "Today",
        yesterday: "Yesterday",
        withinWeek: "Within 7 days",
        earlier: "Earlier",
        moveFailed: "Could not move item",
        projectArchived: "Project archived",
        archiveFailed: "Could not archive project",
        projectDeleted: "Project deleted",
        taskDeleted: "Task deleted",
        moreActions: "More actions",
        pin: "Pin",
        unpin: "Unpin",
        moveToGroup: "Move to group",
        noGroups: "No groups yet",
        moveOutOfGroup: "Remove from group",
        archive: "Archive",
        delete: "Delete",
        manageGroups: "Manage groups",
        rename: "Rename",
        deleteGroup: "Delete group",
        deleteGroupDescription: "Deleting “{{name}}” returns its items to the timeline. The items themselves will not be deleted.",
        confirmDelete: "Confirm deletion",
        deleteItemDescription: "“{{title}}” will be deleted. This action cannot be undone.",
        renameFailed: "Could not rename group",
        groupDeleted: "Group deleted",
        deleteFailed: "Could not delete item",
        noRecords: "No records",
        noRecentWork: "No recent work",
      },
      create: {
        new: "New",
        newChat: "New chat",
        newProject: "New project",
        newDocgen: "New generation task",
        moreOptions: "More create options",
        more: "More create options",
        createGroup: "New group",
        groupCreated: "Group created",
        groupCreateFailed: "Could not create group",
        groupNamePlaceholder: "Group name",
        cancel: "Cancel",
        create: "Create",
      },
      emptyState: {
        seedReady: "Demo knowledge base is being prepared. You can ask questions after parsing finishes.",
        seedFailed: "Could not add the demo library. Try again later.",
        seedTitle: "Add demo knowledge base",
        preparing: "Preparing…",
        seedDescription: "Load inFab product documents and try asking questions",
      },
      chat: {
        assistantConfigHint: "Using the agent’s published model and configuration",
        selectModel: "Select a model",
        openWorkshop: "Open Agent Workshop",
        workshop: "Agent Workshop",
        inputPlaceholder: "Ask a question…",
        docgenExcelPrompt: "Describe the spreadsheet you need, then send to generate it",
        docgenHtmlPrompt: "Describe the web page you need, then send to generate it",
        openWritingStyle: "Writing style opened. Upload past samples to teach AI your company’s style.",
        artifactsLoading: "Loading artifact panel…",
        citationPreviewFailed: "Could not load knowledge-base citation preview",
      },
      composer: {
        attachmentParseComplete: "Attachment parsing complete",
        attachmentParseFailed: "Attachment parsing failed",
        visionUnsupported: "The current model does not support vision. Switch to a VLM model (GPT-4o / Claude 3.5 / GLM-4V).",
        attachmentUploadFailed: "Could not upload “{{name}}”",
        emptyCorpusReference: "The corpus reference returned no content",
        documentReferenceFailed: "Could not reference “{{name}}”. Parse it in Document Center and try again.",
        viewFile: "View file",
        preciseParseComplete: "Precise parsing complete for “{{name}}”",
        preciseParseFailed: "Precise parsing failed for “{{name}}”: {{error}}",
        unknownError: "Unknown error",
        placeholder: "How can I help? For example: summarize a report, draft a proposal, or research an industry…",
        placeholderActive: "Ask a question…",
        trySuggestions: "Try asking",
        suggestionsAria: "Suggested questions",
        attachmentsParsing: "Attachments are still being processed. Please wait…",
        removeUnreadableAttachment: "Remove files that failed to load before sending",
        researchSourcesForBot: "Add research sources. Web search settings follow the agent’s published configuration.",
        researchSourcesForAssistant: "Add research sources or enable web search",
        referenceFailed: "Could not attach {{name}}",
        uploadProgress: "Uploading {{current}}/{{total}} · {{name}}",
        attachmentUsageTitle: "Estimated attachment usage: {{attachmentTokens}} / {{contextTokens}} tokens. This is an estimate; supported tool calls may read files in batches. Each file must be under 20 MB.",
        attachmentUsage: "Attachment usage",
        attachmentBatching: "Files will be read in batches",
        stopGenerating: "Stop generation",
        send: "Send",
        aiDisclaimer: "AI-generated content may be inaccurate. Please verify important details.",
        taskMenu: "Tasks",
        currentAssistant: "current assistant",
        createResearchReport: "Generate research report",
        runAssistantTask: "Run {{name}} task",
        organizeTitle: "Choose a folder for AI to organize: generate summaries, keywords, names, and tag suggestions for review.",
        organizeDocuments: "Organize documents…",
        formatWord: "Word document",
        formatPpt: "PowerPoint presentation",
        formatExcel: "Excel spreadsheet",
        formatHtml: "HTML page",
      },
      greeting: {
        welcome: "Welcome",
        nameSeparator: ", ",
        phrases: {
          lateNight: ["Still up?", "Working late?", "Night owl mode", "Quiet night hours", "Time for some rest"],
          earlyMorning: ["Good early morning", "Up bright and early", "A new day begins", "Morning light is here", "Starting the day early"],
          morning: ["Good morning", "Morning", "A fresh new day", "Ready for the day", "Have a great day"],
          noon: ["Good noon", "Lunch break", "A quiet afternoon break", "Enjoy your lunch", "Take a short break"],
          afternoon: ["Good afternoon", "Afternoon break", "Keep going", "Stay focused", "Make the afternoon count"],
          evening: ["Good evening", "Wind down time", "Thanks for your hard work", "Take a moment to relax", "Have a peaceful evening"],
        },
      },
      suggestion: {
        title: "AI suggestions to review: {{items}}",
        label: "AI suggestions",
      },
      spaceViewing: {
        readOnly: "Viewing {{name}}’s space in read-only mode",
        otherUser: "another user",
      },
    },
  },
} as const;
